import React from "react";
import Header from "../include/Header"
import Contents from "../include/Contents"
import Footer from "../include/Footer"
import Loader from "../include/Loader"
import { gsap } from "gsap";

class Contact extends React.Component{

    componentDidMount(){
        // 사이트 업로드 후 3초 뒤에 inLoading 값이 false로 실행된다.
        setTimeout(()=>{
            document.getElementById("loading").classList.remove("loading-active");
            gsap.set(".main__cont .l1", {opacity: 0, y: 100});
            gsap.set(".main__cont .l2", {opacity: 0, y: 100});
            gsap.set(".main__cont .l3", {opacity: 0, y: 100});
            gsap.set("#header", {opacity: 0, top: "-100%"});
            gsap.set("#footer", {opacity: 0, bottom: "-100%"});
            gsap.set(".script__cont", {opacity: 0});

            gsap.to(".main__cont .l1", {duration: 0.4, delay: 1, y: 0, opacity: 1, ease: "power3.out"});
            gsap.to(".main__cont .l2", {duration: 0.4, delay: 1.2, y: 0, opacity: 1, ease: "power3.out"});
            gsap.to(".main__cont .l3", {duration: 0.4, delay: 1.6, y: 0, opacity: 1, ease: "power3.out"});
            gsap.to("#header", {duration: 0.4, delay: 2, top: 0, opacity: 1, ease: "power3.out"});
            gsap.to("#footer", {duration: 0.4, delay: 2, bottom: 0, opacity: 1, ease: "power3.out"});
            gsap.to(".script__cont", {duration: 0.4, delay: 2, opacity: 1, ease: "power3.out"});
           
        },1500)
    }

    render(){
        return(
            <div>
                <Loader/>
                <Header/>
                    <Contents>
                        <section id="mainCont">
                            <h2 className="sr-only">연락처 컨텐츠 영역입니다.</h2>
                            <div className="main__cont">
                                <div className="l1">You are</div>
                                <div className="l2">already </div>
                                <div className="l3">doing well.</div>
                            </div>
                        </section>
                    </Contents>
                <Footer/>
            </div>
        )
    }
}

export default Contact;